import {
  Button,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@aisquare/ui";
import { ChevronsUpDownIcon } from "lucide-react";
import { Section, VariantBlock } from "../lib/Section";

export function CollapsibleDemo() {
  return (
    <Section
      id="collapsible"
      title="Collapsible"
      description="Single-section show/hide. Lighter than Accordion when grouping isn't needed."
    >
      <VariantBlock label="Default closed">
        <Collapsible className="w-80 space-y-2">
          <div className="flex items-center justify-between">
            <h4 className="text-sm font-medium">@akshit's experiments</h4>
            <CollapsibleTrigger asChild>
              <Button variant="ghost" size="icon-sm" aria-label="toggle">
                <ChevronsUpDownIcon />
              </Button>
            </CollapsibleTrigger>
          </div>
          <div className="rounded-md border border-border bg-card px-3 py-2 text-sm">
            graphify-v2 (always visible)
          </div>
          <CollapsibleContent className="space-y-2">
            <div className="rounded-md border border-border bg-card px-3 py-2 text-sm">
              metricstream-v3
            </div>
            <div className="rounded-md border border-border bg-card px-3 py-2 text-sm">
              dramatyse-fe-rewrite
            </div>
          </CollapsibleContent>
        </Collapsible>
      </VariantBlock>

      <VariantBlock label="Default open">
        <Collapsible defaultOpen className="w-80 space-y-2">
          <CollapsibleTrigger asChild>
            <Button variant="outline" className="w-full justify-between">
              <span>Show details</span>
              <ChevronsUpDownIcon />
            </Button>
          </CollapsibleTrigger>
          <CollapsibleContent className="rounded-md border border-border bg-card p-3 text-sm">
            <p>This section is open by default and can be toggled.</p>
          </CollapsibleContent>
        </Collapsible>
      </VariantBlock>
    </Section>
  );
}
